import { GetAllSourcesListApiResponse } from "@common/types/data-source-types";
import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const getSourcesBySourceNamespace = async (
  namespace: string,
  sourceNamespace: string,
): Promise<GetAllSourcesListApiResponse> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetAllSourcesListApiResponse>(
      `${url}/api/v1/ns/${namespace}/sources/${sourceNamespace}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch sources. Please try again later.",
      );
    }

    throw new Error("An unexpected error occurred while fetching sources.");
  }
};
